module.exports = __webpack_public_path__ + "gt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gt.svg
// module id = 583
// module chunks = 0